
















import { Component, Prop, PropSync, Vue } from "vue-property-decorator"

@Component
export default class BookingReportIssuedBodyMap extends Vue {
  @Prop() readonly bodyParts!: Model[]

  @Prop() readonly gender!: string
  
  @PropSync('isFront') isFrontSynced!: boolean

  @Prop() readonly syncKey!: string

  @PropSync('selectedBodyPart') selectedBodyPartSynced!: string
}
